<template>
  <div>
    <div id="imprimir" class="boleto">
      <!-- <input class="noprint" type="button" value="IMPRIMIR" onClick="window.print();return false" /> -->
      <div class="card" style="border-radius: 13px; padding: 5px;">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <h4 class="text-primary">Olá {{ resposta.name }}</h4>
              <p class="text-info">PAGWISE permite pagar seu boleto com pix!</p>
            </div>
          </div>

          <div class="row">
            <div class="col col-4">
              <div class="row cardvalor">
                <div class="col p-1">
                  <h5 class="text-left text-white">Valor:</h5>
                  <h6 class="text-white">R$ {{ resposta.valor }}</h6>
                </div>
              </div>
              <div class="row cardvencimento mt-1">
                <div class="col p-1">
                  <h5 class="text-left text-white">Vencimento:</h5>
                  <h6 class="text-white">{{ resposta.vencimento }}</h6>
                </div>
              </div>
              <div class="row carddescricao mt-1">
                <div class="col p-1">
                  <h5 class="text-left text-info">Descrição:</h5>
                  <p>{{ resposta.descricao }}</p>
                </div>
              </div>

              <div class="row carddescricao mt-1">
                <div class="col p-1">
                  <h5 class="text-left text-info">Após o vencimento:</h5>
                  <p>Juros: 10%</p>
                  <p>Multa: 2%</p>
                </div>
              </div>
            </div>
            <div class="col col-8">
              <div class="row">
                <div class="col">
                  <qrcode
                    :value="resposta.textoImagemQRcode"
                    :options="options"
                  ></qrcode>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-1">
            <div class="col"><p class="text-info">PIX copia e cola:</p></div>
          </div>

          <div class="row">
            <div class="input-group">
              <input
                id="pixCopiaCola"
                :value="resposta.textoImagemQRcode"
                type="text"
                class="form-control"
              />
              <div class="input-group-prepend">
                <button
                  type="button"
                  class="btn btn-info btn-sm"
                  @click="copyToClipboard()"
                >
                  Copiar
                </button>
              </div>
            </div>
          </div>

          <div class="row">
            <table cellSpacing="0" cellPadding="0" border="0" class="">
              <tr>
                <td style="width: 0.9cm;"></td>
                <td style="width: 1cm;"></td>
                <td style="width: 1.9cm;"></td>
                <td style="width: 0.5cm;"></td>
                <td style="width: 1.3cm;"></td>
                <td style="width: 0.8cm;"></td>
                <td style="width: 1cm;"></td>
                <td style="width: 1.9cm;"></td>
                <td style="width: 1.9cm;"></td>
                <td style="width: 3.8cm;"></td>
                <td style="width: 3.8cm;"></td>
              </tr>

              <tr>
                <td colspan="11" height="20" valign="top">&nbsp</td>
              </tr>
              <tr>
                <td colspan="11" class="BoletoPontilhado">&nbsp;</td>
              </tr>
              <tr>
                <td colspan="4" class="BoletoLogo">
                  <img
                    src="data:image/jpeg;base64,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"
                    alt=""
                  />
                </td>
                <td colspan="2" class="BoletoCodigoBanco">001-9</td>
                <td
                  v-mask="dynamicMask"
                  colspan="6"
                  class="BoletoLinhaDigitavel"
                >
                  {{ resposta.linhaDigitavel }}
                </td>
              </tr>
              <tr>
                <td colspan="10" class="BoletoTituloEsquerdo">
                  Local de Pagamento
                </td>
                <td class="BoletoTituloDireito">Vencimento</td>
              </tr>
              <tr>
                <td
                  colspan="10"
                  class="BoletoValorEsquerdo"
                  style="text-align: left; padding-left: 0.1cm;"
                >
                  Pagável em qualquer agência bancária
                </td>
                <td class="BoletoValorDireito">{{ resposta.vencimento }}</td>
              </tr>
              <tr>
                <td colspan="8" class="BoletoTituloEsquerdo">Beneficiário</td>
                <td colspan="2" class="BoletoTituloEsquerdo">
                  CPF/CNPJ do Beneficiário
                </td>
                <td class="BoletoTituloDireito">
                  Agencia/Codigo do Beneficiário
                </td>
              </tr>
              <tr>
                <td
                  colspan="8"
                  class="BoletoValorEsquerdo"
                  style="text-align: left; padding-left: 0.1cm;"
                >
                  PagWise
                </td>
                <td colspan="2" class="BoletoValorEsquerdo">
                  {{ resposta.documento }}
                </td>
                <td class="BoletoValorDireito">4336</td>
              </tr>
              <tr>
                <td colspan="3" class="BoletoTituloEsquerdo">
                  Data do Documento
                </td>
                <td colspan="4" class="BoletoTituloEsquerdo">
                  Nr. do Documento
                </td>
                <td class="BoletoTituloEsquerdo">Espécie Doc</td>
                <td class="BoletoTituloEsquerdo">Aceite</td>
                <td class="BoletoTituloEsquerdo">Data do Processamento</td>
                <td class="BoletoTituloDireito">Nosso Número</td>
              </tr>
              <tr>
                <td colspan="3" class="BoletoValorEsquerdo"></td>
                <td colspan="4" class="BoletoValorEsquerdo"></td>
                <td class="BoletoValorEsquerdo">RC</td>
                <td class="BoletoValorEsquerdo">N</td>
                <td class="BoletoValorEsquerdo"></td>
                <td class="BoletoValorDireito"></td>
              </tr>
              <tr>
                <td colspan="3" class="BoletoTituloEsquerdo">Uso do Banco</td>
                <td colspan="2" class="BoletoTituloEsquerdo">Carteira</td>
                <td colspan="2" class="BoletoTituloEsquerdo">Moeda</td>
                <td colspan="2" class="BoletoTituloEsquerdo">Quantidade</td>
                <td class="BoletoTituloEsquerdo">(x) Valor</td>
                <td class="BoletoTituloDireito">(=) Valor do Documento</td>
              </tr>
              <tr>
                <td colspan="3" class="BoletoValorEsquerdo">&nbsp;</td>
                <td colspan="2" class="BoletoValorEsquerdo">17</td>
                <td colspan="2" class="BoletoValorEsquerdo">R$</td>
                <td colspan="2" class="BoletoValorEsquerdo">&nbsp;</td>
                <td class="BoletoValorEsquerdo"></td>
                <td class="BoletoValorDireito">R$ {{ resposta.valor }}</td>
              </tr>
              <tr>
                <td colspan="10" class="BoletoTituloEsquerdo">Instruções</td>
                <td class="BoletoTituloDireito">(-) Desconto</td>
              </tr>
              <tr>
                <td
                  colspan="10"
                  rowspan="9"
                  class="BoletoValorEsquerdo"
                  style="
                    text-align: left;
                    vertical-align: top;
                    padding-left: 0.1cm;
                  "
                >
                  Pagável em qualquer agência bancária
                </td>

                <td style="height: 20px;" class="BoletoValorDireito">&nbsp;</td>
              </tr>
              <tr>
                <td class="BoletoTituloDireito">
                  (-) Outras Deduções/Abatimento
                </td>
              </tr>
              <tr>
                <td style="height: 20px;" class="BoletoValorDireito">&nbsp;</td>
              </tr>
              <tr>
                <td class="BoletoTituloDireito">(+) Mora/Multa/Juros</td>
              </tr>
              <tr>
                <td style="height: 20px;" class="BoletoValorDireito">&nbsp;</td>
              </tr>
              <tr>
                <td class="BoletoTituloDireito">(+) Outros Acréscimos</td>
              </tr>
              <tr>
                <td style="height: 20px;" class="BoletoValorDireito">&nbsp;</td>
              </tr>
              <tr>
                <td class="BoletoTituloDireito">(=) Valor Cobrado</td>
              </tr>
              <tr>
                <td style="height: 20px;" class="BoletoValorDireito">&nbsp;</td>
              </tr>
              <tr>
                <td rowspan="3" Class="BoletoTituloSacado">Pagador:</td>
                <td colspan="1" Class="BoletoValorSacado"></td>
                <td colspan="7" Class="BoletoValorSacado">
                  Osmar Junior Chimello - CPF 04930489954
                </td>
              </tr>
              <tr>
                <td colspan="10" Class="BoletoValorSacado"></td>
              </tr>
              <tr>
                <td
                  style="height: 40px;"
                  colspan="10"
                  Class="BoletoValorSacado"
                >
                  &nbsp;&nbsp;&nbsp;
                </td>
              </tr>
              <tr>
                <td colspan="2" Class="BoletoTituloSacador">
                  Sacador / Avalista:
                </td>
                <td colspan="9" Class="BoletoValorSacador"></td>
              </tr>
              <tr>
                <td
                  colspan="11"
                  class="BoletoTituloDireito"
                  style="text-align: right; padding-right: 0.1cm;"
                >
                  Ficha de Compensação - Autenticação Mecanica
                </td>
              </tr>
              <tr>
                <td colspan="11" class="text-left" valign="top">
                  <VueBarcode
                    width="2"
                    height="50"
                    :displayValue="false"
                    v-bind:value="resposta.codigoBarraNumerico"
                  >
                  </VueBarcode>
                </td>
              </tr>
              <tr>
                <td colspan="11" class="BoletoPontilhado">&nbsp;</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BTable,
  BProgress,
  BBadge,
  BButton,
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
} from "bootstrap-vue";

import qrcode from "tui-vue-qrcode";
export default {
  components: {
    BTable,
    BProgress,
    BBadge,
    BButton,
    BRow,
    BCol,
    qrcode,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
  },
  data() {
    return {
      boleto: false,
      options: { size: 300 },
      isPix: false,
      show: false,
      resposta: {},
    };
  },
  computed: {
    list_order() {
      return this.$store.state.estabelecimentos.list_order;
    },
  },
  methods: {
    abrirModalBoleto(value) {
      console.log(value);
      this.resposta = value;
      this.boleto = true;
    },
  },
};
</script>

<style>
@media print {
  body * {
    visibility: hidden;
  }
  #imprimir,
  #imprimir * {
    visibility: visible;
    max-width: 100%;
    width: 100%;
   
    
  }
}

#imprimir {
  text-align: center;
  max-width: 50%;
  margin-left: auto;
  margin-right: auto;
}
td.BoletoCodigoBanco {
  font-size: 6mm;
  font-family: arial, verdana;
  font-weight: bold;
  font-style: italic;
  text-align: center;
  vertical-align: bottom;
  border-bottom: 0.15mm solid #000000;
  border-right: 0.15mm solid #000000;
  padding-bottom: 1mm;
}

td.BoletoLogo {
  border-bottom: 0.15mm solid #000000;
  border-right: 0.15mm solid #000000;
  text-align: center;
  height: 10mm;

  /*
      max-height:10mm;
      width: auto;
      height: auto;
      */
}

td.BoletoLinhaDigitavel {
  font-size: 4 mm;
  font-family: arial, verdana;
  font-weight: bold;
  text-align: center;
  vertical-align: bottom;
  border-bottom: 0.15mm solid #000000;
  padding-bottom: 1mm;
}

td.BoletoTituloEsquerdo {
  font-size: 0.2cm;
  font-family: arial, verdana;
  padding-left: 0.15mm;
  border-right: 0.15mm solid #000000;
  text-align: left;
}

td.BoletoTituloDireito {
  font-size: 2mm;
  font-family: arial, verdana;
  padding-left: 0.15mm;
  text-align: left;
}

td.BoletoValorEsquerdo {
  font-size: 3mm;
  font-family: arial, verdana;
  text-align: center;
  border-right: 0.15mm solid #000000;
  font-weight: bold;
  border-bottom: 0.15mm solid #000000;
  padding-top: 0.5mm;
}

td.BoletoValorDireito {
  font-size: 3mm;
  font-family: arial, verdana;
  text-align: right;
  padding-right: 3mm;
  padding-top: 0.8mm;
  border-bottom: 0.15mm solid #000000;
  font-weight: bold;
}

td.BoletoTituloSacado {
  font-size: 2mm;
  font-family: arial, verdana;
  padding-left: 0.15mm;
  vertical-align: top;
  padding-top: 0.15mm;
  text-align: left;
}

td.BoletoValorSacado {
  font-size: 3mm;
  font-family: arial, verdana;
  font-weight: bold;
  text-align: left;
}

td.BoletoTituloSacador {
  font-size: 2mm;
  font-family: arial, verdana;
  padding-left: 0.15mm;
  vertical-align: bottom;
  padding-bottom: 0.8mm;
  border-bottom: 0.15mm solid #000000;
}

td.BoletoValorSacador {
  font-size: 3mm;
  font-family: arial, verdana;
  vertical-align: bottom;
  padding-bottom: 0.15mm;
  border-bottom: 0.15mm solid #000000;
  font-weight: bold;
  text-align: left;
}

td.BoletoPontilhado {
  border-top: 0.3mm dashed #000000;
  font-size: 1mm;
}

ul.BoletoInstrucoes {
  font-size: 3mm;
  font-family: verdana, arial;
}

.cardvalor {
  background-color: #1155d4;
  border-radius: 13px;
  color: #fff;
}
.cardvencimento {
  background-color: #1193d4;
  border-radius: 13px;
  color: #fff;
}
.carddescricao {
  background-color: #eef4f6;
  border-radius: 13px;
  color: rgb(56, 52, 52);
}
body {
  background-color: #f6f6f6;
}
</style>
